import { createReducer } from 'redux-act';
import * as actions from '#app/actions/obligation';

interface ObligationState {
  modalVisible: boolean;
  form: Record<string, unknown>;
}

const initialState: ObligationState = {
  modalVisible: false,
  form: {},
};

const setObligationModalVisible = (state: ObligationState, bool: boolean): ObligationState => ({
  ...state,
  modalVisible: bool,
});

const setObligationForm = (
  state: ObligationState,
  form: Record<string, unknown>
): ObligationState => ({
  ...state,
  form: form,
  modalVisible: true,
});

const closeObligationForm = (state: ObligationState): ObligationState => ({
  ...state,
  form: {},
  modalVisible: false,
});

export default createReducer<ObligationState>(
  {
    [actions.setObligationModalVisible.getType()]: setObligationModalVisible,
    [actions.setObligationForm.getType()]: setObligationForm,
    [actions.closeObligationForm.getType()]: closeObligationForm,
  },
  initialState
);
